import React, {FunctionComponent, ReactElement} from 'react';
import {useSelector} from 'react-redux';
import {useRouteMatch} from 'react-router-dom';

import {LeftDrawerTarget} from '../LeftDrawer';
import {LeftMenuTarget} from '../LeftMenu';
import {IState} from '../../../store/reducers';

import './PanelWithLeftMenu.scss';

type PanelWithLeftMenuProps = {
  large?: boolean;
  menuContent?: ReactElement;
};

const InnerPanelWithLeftMenu: FunctionComponent<PanelWithLeftMenuProps> = ({
  large,
  menuContent,
  children
}: any) => {
  const backgroundKind = useSelector((state: IState) => state.ui.backgroundKind);

  // DECIDE IF LEFT MENU IS AVAILABLE
  const adminMatch = useRouteMatch('/a/*');

  const isAdmin = (adminMatch?.isExact && !adminMatch?.url.startsWith('/a/log')) || false;
  const isExecutionHistory = (adminMatch?.isExact && adminMatch?.url.startsWith('/a/log')) || false;

  // Always show left menu on admin page and execution history page
  const hasSidebar = isAdmin || isExecutionHistory;

  const background = backgroundKind !== 'default' ? backgroundKind : '';

  return (
    <div className="page">
      <div>
        <LeftDrawerTarget/>
      </div>
      {hasSidebar && (
        <aside
          className={`page__left-menu ${large ? 'large' : ''}`}
        >
          {menuContent ? menuContent : <LeftMenuTarget className="page__left-menu__wrapper"/>}
        </aside>
      )}
      <main
        id="page__content"
        className={`page__content ${background} ${large ? 'large' : ''} ${!hasSidebar ? 'no-left-menu' : ''}`}
      >
        <div className="page__content__container">{children}</div>
      </main>
    </div>
  );
};

export const PanelWithLeftMenu: FunctionComponent<PanelWithLeftMenuProps> = ({
  large,
  menuContent,
  children
}: any) => (
  <InnerPanelWithLeftMenu
    menuContent={menuContent}
    large={large}
  >
    {children}
  </InnerPanelWithLeftMenu>
);
